var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 43C33.598 43 43 33.598 43 22C43 10.402 33.598 1 22 1C10.402 1 1 10.402 1 22C1 33.598 10.402 43 22 43Z",
    stroke: "#F2F2F2",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5261 16.8457C31.4161 16.2841 32.099 15.3936 32.4194 14.3328C31.5862 14.8541 30.6654 15.2311 29.683 15.4352C28.8991 14.5512 27.7787 14 26.5387 14C24.1597 14 22.2319 16.0345 22.2319 18.5436C22.2319 18.8998 22.2677 19.2469 22.3416 19.5784C18.7621 19.3886 15.5881 17.5815 13.4619 14.8307C13.0909 15.5041 12.8789 16.2841 12.8789 17.1161C12.8789 18.6918 13.6394 20.0828 14.7956 20.8992C14.0893 20.8758 13.4249 20.6691 12.8431 20.3311V20.387C12.8431 22.5892 14.3272 24.4261 16.3006 24.8421C15.9382 24.9487 15.5585 25.002 15.1641 25.002C14.8868 25.002 14.6156 24.9747 14.3543 24.9214C14.9016 26.7258 16.4929 28.0415 18.3788 28.0766C16.9033 29.296 15.0458 30.0214 13.028 30.0214C12.6804 30.0214 12.3365 30.0019 12 29.959C13.9068 31.2473 16.1712 32 18.6043 32C26.53 32 30.8614 25.0761 30.8614 19.0714C30.8614 18.8738 30.859 18.6775 30.8503 18.4837C31.6922 17.8428 32.4244 17.042 33 16.1307C32.2272 16.4921 31.3964 16.7365 30.5261 16.8457Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwIcon);
export default __webpack_public_path__ + "static/media/tw-icon.ea1c65806f9494ae433ec8b7fe18075c.svg";
export { ForwardRef as ReactComponent };